import { phoneNumberRegex, regexEmail } from 'shell/constants/regex';
import * as yup from 'yup';

export const recapValidationSchema = yup.object({
  telephone: yup.string().nullable(),
  phone: yup
    .string()
    .matches(phoneNumberRegex, 'Il campo deve essere un numero telefonico')
    .nullable(),
  email: yup.string().matches(regexEmail, 'Il campo deve essere una email').nullable(),
  pec: yup.string().matches(regexEmail, 'Il campo deve essere una email').nullable(),
  note: yup.string().nullable(),
});
